import { AxiosResponse } from 'axios'
import { GiftCard } from '@playback-rewards/shared-libraries'
import { GetGiftCardResponse } from '../types'
import axiosWebInstance from '../axiosWebInstance'

export const getAllGiftCards = async (): Promise<AxiosResponse<GiftCard[], Error>> => {
  return axiosWebInstance.get('/api/v1/gift-cards/')
}

export const getGiftCardById = async (
  giftCardId?: string
): Promise<AxiosResponse<GetGiftCardResponse, Error>> => {
  if (!giftCardId) {
    throw new Error('giftCardId is required')
  }

  return axiosWebInstance.get(`/api/v1/gift-cards/${giftCardId}`)
}

export const getTremendousCampaign = async (campaignId: string) => {
  return axiosWebInstance.get(`/api/v1/gift-cards/campaign/${campaignId}`)
}
